import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../utils/api";

interface logsType {
  id: number;
  case_id: string;
  title: string;
  By: string;
  body: string;
  creation_ts: string;
}

interface logsState {
  logs: logsType[];
  isLoading: boolean;
  error: string | null;
}

const initialState: logsState = {
  logs: [],
  isLoading: false,
  error: null,
};

export const getCaseLogsByCaseId = createAsyncThunk(
  "admin/case-logs",
  async (caseId: string, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `/common/logs/case/${caseId}`
      );
      return response.data?.data as logsType[];
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch case logs",
      );
    }
  },
);

const loggingSlice = createSlice({
  name: "logging",
  initialState,
  reducers: {
    clearCaseLogs: (state) => {
      state.logs = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCaseLogsByCaseId.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getCaseLogsByCaseId.fulfilled, (state, action) => {
        state.isLoading = false;
        state.logs = action.payload;
      })
      .addCase(getCaseLogsByCaseId.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearCaseLogs } = loggingSlice.actions;
export default loggingSlice.reducer;
